(() => {
  const italian = document.documentElement.lang.toLowerCase().startsWith('it');
  const content = document.querySelector('.mn-info--resi-e-rimborsi .shopify-section--main-page .prose');
  if (!content) return;
  for (const link of content.querySelectorAll('a[href]')) {
    let url;
    try { url = new URL(link.href); } catch { continue; }
    const portal = url.hostname === 'returns.itsrever.com';
    const pdf = url.hostname === location.hostname && /\/modulo-reso[^/]*\.pdf$/i.test(url.pathname);
    if (!portal && !pdf) continue;
    link.classList.add('mn-return-action');
    if (portal) link.classList.add('mn-return-action--portal');
    // Replace only an unhelpful bare URL, retaining authored labels and destinations.
    if (link.textContent.trim() === link.href || link.textContent.trim() === link.getAttribute('href')) {
      link.textContent = portal ? (italian ? 'Avvia un reso online' : 'Start an online return') : (italian ? 'Scarica il modulo di reso' : 'Download the return form');
    }
  }
})();
